import App from "./App.svelte"
let app // Declare 'app' but don't initialize it yet

/* ---------- Receive URL from IndianStates.org --------- */
function receiveURL(event) {
  const URL = event.data
  // Check the type of the message
  if (typeof URL === "string" && isValidUrl(URL)) {
    console.log("Received URL from parent: " + URL)
    // Update the app with the new URL
    app.$set({ parentUrl: URL })
    // return
  } else {
    // let path = 'sectors'
    // let path = 'sectors/center-state-relations'
    // let path = "sectors/land-labor-laws"
    // let path = "sectors/water-sanitation"
    // let path = "states/andhra-pradesh"
    // let path = "states"
    // let path = "newsletter"
    // let path = "articles"
    
    // app.$set({
      // parentUrl: "https://localhost:4000/" + path,
    //   parentUrl: "https://dev--indian-states-v2.netlify.app/" + path,
    // })
    console.log("Received non-URL message: ", URL)
  }
}

// validate message from indian states is valid URL
// or that URL is from localhost in development
function isValidUrl(string) {
  try {
    // Adding a check for localhost URLs
    if (string.startsWith("localhost") || string.startsWith("127.0.0.1")) {
      string = "http://" + string;
    }
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}


/* ---------- Create the Svelte app --------- */
app = new App({
  target: document.body,
  props: {
    /*In development, hardcode the parentUrl to work without IndianStates
    site running*/
    // parentUrl: "https://indianstates.csis.org/sectors/climate-change-and-energy",
    // parentUrl: "https://dev--indian-states-v2.netlify.app/sectors/"
    /*In production, set parentUrl to an empty string*/
    parentUrl: '',
  },
})

/* ---------- Listen for messages from IndianStates --------- */
/* comment out during development */
window.addEventListener("message", receiveURL, false)

export default app
